"use strict";

exports.__esModule = true;
exports.default = propertyOf;
var _noop = _interopRequireDefault(require("./noop.js"));
var _get = _interopRequireDefault(require("./get.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return _noop.default;
  return function (path) {
    return (0, _get.default)(obj, path);
  };
}